// extracted by mini-css-extract-plugin
export default {"content":"style_content__RtXdb","user":"style_user__H5KdN","table":"style_table__lD96p"};